import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";

// Route-level code splitting keeps the initial bundle small (faster first load)
const About = lazy(() => import("@/pages/About"));
const Services = lazy(() => import("@/pages/Services"));
const Mission = lazy(() => import("@/pages/Mission"));
const WhyChooseUs = lazy(() => import("@/pages/WhyChooseUs"));
const Contact = lazy(() => import("@/pages/Contact"));
const Quote = lazy(() => import("@/pages/Quote"));

const Fallback = () => (
  <div className="flex min-h-screen items-center justify-center bg-navy" />
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Navbar />
          <main>
            <Suspense fallback={<Fallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/mission" element={<Mission />} />
                <Route path="/why-choose-us" element={<WhyChooseUs />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/quote" element={<Quote />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
